import type { ActiveFilter } from '../types/admin'

interface FilterChipsProps {
  filters: ActiveFilter[]
  onRemove: (index: number) => void
  onClearAll: () => void
}

export function FilterChips({ filters, onRemove, onClearAll }: FilterChipsProps) {
  if (filters.length === 0) return null

  return (
    <div className="filter-chips-bar">
      {filters.map((f, i) => (
        <span key={`${f.questionId}-${f.value}-${i}`} className="filter-chip">
          <span className="filter-chip-label">{f.questionLabel}: {f.value}</span>
          <button className="filter-chip-dismiss" onClick={() => onRemove(i)} aria-label={`Remove filter ${f.questionLabel}: ${f.value}`}>&times;</button>
        </span>
      ))}
      {filters.length > 1 && (
        <button className="filter-chip-clear" onClick={onClearAll}>Clear all</button>
      )}
    </div>
  )
}
